import React from "react";
import { Button, Overlay, Tooltip } from "react-bootstrap";
import {FaDownload} from "react-icons/fa";
import {BASE_DEPLOY_PATH} from "../../index";

function ViewerWrapper({
  children,
  isExcelViewer,
  isCodeViewer,
  isImageViewer,
  fileUrl,
  isEbookViewer,
  isAudioViewer,
  isVideoViewer, // Add this prop
}) {
  const [showTooltip, setShowTooltip] = React.useState(false);
  const copyButtonRef = React.useRef(null);

  const handleDownload = () => {
    if (fileUrl) {
      const link = document.createElement("a");
      link.href = fileUrl;
      link.download = fileUrl.split("/").pop();
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const handleCopyLink = () => {
    if (fileUrl) {
      navigator.clipboard.writeText(fileUrl);
      setShowTooltip(true);
      setTimeout(() => setShowTooltip(false), 1500);
    }
  };

  return (
    <div className="viewer-wrapper">
      <div className="viewer-container">
        <div className="button-group">
          {fileUrl && (
            <>
              <Button
                variant="outline-primary"
                onClick={handleDownload}
                className="d-flex align-items-center"
              >
                <FaDownload size={18} style={{ marginRight: "5px" }} />{" "}
                Download
              </Button>
              {!isAudioViewer && (
                <Button
                  variant={isCodeViewer ? "secondary" : "outline-secondary"}
                  ref={copyButtonRef}
                  onClick={handleCopyLink}
                  className="d-flex align-items-center"
                >
                  <img src={`${BASE_DEPLOY_PATH}/assets/link.png`} height={15} />
                </Button>
              )}
              <Overlay
                target={copyButtonRef.current}
                show={showTooltip}
                placement="bottom"
              >
                {(props) => <Tooltip {...props}>Copied direct file link</Tooltip>}
              </Overlay>
            </>
          )}
        </div>
      </div>
      <div className="content-container">{children}</div>
      <style jsx>{`
        .viewer-wrapper {
          position: relative;
          max-height: 90vh;
          overflow: "hidden";

          border: ${isCodeViewer ? "1px solid #374151" : "none"};
          border-radius: ${isCodeViewer ? "16px" : "12px"};
          margin: 1rem;
          background-color: ${isCodeViewer
            ? "#1a1a1a"
            : isImageViewer
            ? // ? "#f0f0f0"
              "transparent"
            : "transparent"};
        }

        .viewer-container {
          position: relative;
          height: 50px;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          padding: ${isCodeViewer ? "0 8px" : "0 2px"};
        }

        .content-container {
          position: relative;
          max-height: calc(100% - 50px);
          overflow: auto;
          border-radius: ${isCodeViewer ? "" : "12px"};
        }

        .download-button {
          padding: 6px 12px;
          background-color: #374151;
          color: white;
          border: none;
          border-radius: 4px;
          cursor: pointer;
          transition: background-color 0.2s;
        }

        .download-button:hover {
          background-color: #4b5563;
        }

        .button-group {
          display: flex;
          gap: 8px;
        }
      `}</style>
    </div>
  );
}

export default ViewerWrapper;
